import React, { FunctionComponent } from 'react'
import { IProps } from './IProps'
import style from './style.scss'

const Result: FunctionComponent<IProps> = (props: IProps) => {
  let profilePicture = ''

  if (props.customer.image === null) {
    props.customer.gender === 'M'
      ? (profilePicture = '/img/avatar-male.png')
      : (profilePicture = '/img/avatar-female.png')
  } else {
    profilePicture =
      '//files.optios.net/?id=' + props.customer.image + '&w=44&h=44&fit=crop'
  }

  return (
    <>
      <div className={style.customerCard} onClick={() => props.onSelected()}>
        <div className={style.avatar}>
          <img alt={props.customer.fullName} src={profilePicture} />
        </div>
        <div className={style.name}>{props.customer.fullName}</div>
        <div className={style.address}>{props.customer.address}</div>
      </div>
    </>
  )
}

export default Result;
